import React from 'react'

import { useNutrimaticMobileScrollLock } from '@/widgets/swap/nutrimatic/useNutrimaticMobileScrollLock'

/** Shell móvil Nutri-Matic para flujos operativos de liquidez (add / remove / import). */
export function LiquidityNutrimaticMobileShell({ children }: { children: React.ReactNode }) {
  useNutrimaticMobileScrollLock()

  return (
    <div
      data-nutrimatic-mobile-shell
      data-nutrimatic-mobile-simple
      className="nm-mobile-simple flex min-h-0 flex-1 flex-col overflow-hidden"
    >
      <div className="nm-mobile-simple__shell-top">
        <div className="nm-mobile-simple__brand-accent" aria-hidden />
      </div>

      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">{children}</div>
    </div>
  )
}
